import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { CompassFlags } from 'app/shared/flags/compass-flags';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssDropdownPage extends ComponentBase {

    protected directions: { direction: string, flag: number }[] = [
        { direction: 'Down', flag: CompassFlags.Down },
        { direction: 'Up', flag: CompassFlags.Up },
        { direction: 'Left', flag: CompassFlags.Left },
        { direction: 'Right', flag: CompassFlags.Right },
        { direction: 'DownLeft', flag: CompassFlags.DownLeft },
        { direction: 'DownRight', flag: CompassFlags.DownRight },
        { direction: 'UpLeft', flag: CompassFlags.UpLeft },
        { direction: 'UpRight', flag: CompassFlags.UpRight },
        { direction: 'Horizontal', flag: CompassFlags.Horizontal },
        { direction: 'Vertical', flag: CompassFlags.Vertical },
    ];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Functions ********************************************////
    protected getState(state: number): string {
        switch(state) {
            case 1:
                return '1 - Open';
            case 2:
                return '2 - Closed';
            case 4:
                return '4 - Transitioning';
            case 5:
                return '5 - Opening';
            case 6:
                return '6 - Closing';
            default:
                return 'N/A';
        }
    }

    protected handleClick(event: MouseEvent, example: number): void {
        if(example === 1) this.ex1Selected = (event.target as HTMLElement).textContent!;
        if(example === 2) this.ex2Selected = (event.target as HTMLElement).textContent!;
    }

    ////****************** Example 2 ********************************************////
    protected ex1Selected: string = '';

    ////****************** Example 2 ********************************************////
    protected ex2Direction = this.directions[0];
    protected ex2Selected: string = '';

}
